export enum Gender {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
}

export interface Athlete {
  id: string;
  name: string;
  lastName: string;
  gender: Gender;
}

export interface CreateAthleteInput {
  name: string;
  lastName: string;
  gender: Gender;
}

export interface UpdateAthleteInput {
  name?: string;
  lastName?: string;
  gender?: Gender;
}
